import React from "react";
import {
  IoAdd,
  IoAlertCircle,
  IoArrowDownOutline,
  IoArrowUpOutline,
  IoCalendarOutline,
  IoCheckbox,
  IoCheckmarkCircle,
  IoCheckmarkSharp,
  IoChevronDown,
  IoChevronUp,
  IoClose,
  IoConstructOutline,
  IoCreateOutline,
  IoCubeOutline,
  IoDocumentTextOutline,
  IoDownloadOutline,
  IoFlagOutline,
  IoFolderOutline,
  IoTrashOutline,
  IoHelpCircle,
  IoHomeOutline,
  IoLogOutOutline,
  IoPeopleOutline,
  IoPersonAdd,
  IoQrCodeOutline,
  IoReceiptOutline,
  IoSearch,
  IoWaterOutline,
} from "react-icons/io5";

/**
 * Icônes de l'espace CP manager.
 *
 * Le design utilise les web components `<ion-icon>`, qui supposent de charger
 * ionicons depuis un CDN. On passe par `react-icons`, déjà présent dans les
 * dépendances et qui embarque le même jeu (Ionicons 5) : pas de requête
 * externe, pas de dépendance nouvelle, et les SVG sont tree-shakés.
 *
 * Les noms restent ceux du design pour que la correspondance avec
 * « WOSH Beheerportaal.dc.html » reste lisible.
 */
const ICONS = {
  add: IoAdd,
  "alert-circle": IoAlertCircle,
  "arrow-down-outline": IoArrowDownOutline,
  "arrow-up-outline": IoArrowUpOutline,
  "calendar-outline": IoCalendarOutline,
  checkbox: IoCheckbox,
  "checkmark-circle": IoCheckmarkCircle,
  "checkmark-sharp": IoCheckmarkSharp,
  "chevron-down": IoChevronDown,
  "chevron-up": IoChevronUp,
  close: IoClose,
  "construct-outline": IoConstructOutline,
  "create-outline": IoCreateOutline,
  "cube-outline": IoCubeOutline,
  "document-text-outline": IoDocumentTextOutline,
  "download-outline": IoDownloadOutline,
  "flag-outline": IoFlagOutline,
  "folder-outline": IoFolderOutline,
  "trash-outline": IoTrashOutline,
  "help-circle": IoHelpCircle,
  "home-outline": IoHomeOutline,
  "log-out-outline": IoLogOutOutline,
  "people-outline": IoPeopleOutline,
  "person-add": IoPersonAdd,
  "qr-code-outline": IoQrCodeOutline,
  "receipt-outline": IoReceiptOutline,
  search: IoSearch,
  "water-outline": IoWaterOutline,
};

/**
 * `size` vaut 1em : l'icône suit la taille de police de son parent, exactement
 * comme le faisait `<ion-icon>`. Les `style={{ fontSize }}` du design continuent
 * donc de fonctionner tels quels.
 */
const Icon = ({ name, style, ...rest }) => {
  const Glyph = ICONS[name];

  if (!Glyph) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`[Manager] Icône inconnue : "${name}"`);
    }
    return null;
  }

  return (
    <Glyph
      size="1em"
      style={{ flexShrink: 0, verticalAlign: "middle", ...style }}
      aria-hidden="true"
      focusable="false"
      {...rest}
    />
  );
};

export default Icon;
